"use client";

import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { useCollapseContext } from "./collapse-context";

/**
 * Button to fold/expand all cards in a message.
 * Only renders when there are 2 or more collapsible cards.
 */
export function FoldAllButton() {
  const context = useCollapseContext();

  // Don't render if no context or fewer than 2 cards
  if (!context || context.registeredCards.size < 2) {
    return null;
  }

  const allCollapsed =
    context.collapsedCards.size === context.registeredCards.size;

  const handleClick = () => {
    if (allCollapsed) {
      context.expandAll();
    } else {
      context.collapseAll();
    }
  };

  return (
    <button
      className="flex items-center gap-1.5 rounded-lg border bg-muted/30 px-3 py-1.5 text-muted-foreground text-sm transition-colors hover:bg-muted/50 hover:text-foreground"
      onClick={handleClick}
      type="button"
    >
      {allCollapsed ? (
        <>
          <ChevronDownIcon className="size-4" />
          <span>Expand All Cards</span>
        </>
      ) : (
        <>
          <ChevronUpIcon className="size-4" />
          <span>Fold All Cards</span>
        </>
      )}
    </button>
  );
}
